import React from 'react';
import { Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import LoginForm from './LoginForm';

const Login = () =>
<>
  <Row className="text-left justify-content-between">
    <Col xs="auto">
      <h5>Iniciar sesión</h5>
    </Col>
    <Col xs="auto">
      <p className="fs--1 text-600">
        ó <Link to="/register">crear una cuenta</Link>
      </p>
    </Col>
  </Row>
  <LoginForm />
</>

export default Login;